import type { Dispatch } from '@atlaskit/editor-common/event-dispatcher';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export type MalleableUiPluginState = {
	isRemixModalOpen: boolean;
};

export type MalleableUiPluginMeta = {
	isRemixModalOpen?: boolean;
};

export const malleableUiPluginKey = new PluginKey<MalleableUiPluginState>('malleableUiPlugin');

export function createMalleableUiPmPlugin(dispatch: Dispatch): SafePlugin {
	return new SafePlugin({
		key: malleableUiPluginKey,
		state: {
			init(): MalleableUiPluginState {
				return {
					isRemixModalOpen: false,
				};
			},
			apply(tr, pluginState): MalleableUiPluginState {
				const meta: MalleableUiPluginMeta | undefined = tr.getMeta(malleableUiPluginKey);

				if (meta && meta.isRemixModalOpen !== undefined) {
					const result: MalleableUiPluginState = {
						isRemixModalOpen: meta.isRemixModalOpen,
					};
					dispatch(malleableUiPluginKey, result);
					return result;
				}

				return pluginState;
			},
		},
	});
}
